import React from 'react';

import { useListItemStyles as useStylesheet } from './stylesheets';
import { RecursiveShortcodeProps } from './Shortcode';

const ListItem = ({ RecursiveShortcode, elements, ...rest }: RecursiveShortcodeProps) => {
  const { against, attributes, layout } = rest;
  const { styles } = useStylesheet({
    against,
    attributes,
    layout,
  });
  return (
    <li style={styles.root}>
      <span style={styles.text}>
        {/* @ts-ignore: error when upgrading to @ux/config */}
        <RecursiveShortcode elements={elements} {...rest} />
      </span>
    </li>
  );
};
ListItem.displayName = 'ListItem';

export default ListItem;
